import { render, staticRenderFns } from "./TimeSeriesManual.vue?vue&type=template&id=389cf154&"
import script from "./TimeSeriesManual.vue?vue&type=script&lang=ts&"
export * from "./TimeSeriesManual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports